import { useHistory } from "react-router-dom";

//componentes
import { MigasDePan, Miga } from "../../../globales/MigaDePan";
import TituloSeccion from "../../../globales/estadisticas/TituloSeccion";
import TablaIngresos from "./TablaIngresos";
import { useDispatch, useTrackedState } from "../../../../store";
import { useQueryParams } from "../../../../containers/helpers/hooks/locationHooks";
import { useEffect, useState } from "react";
import { FiltroFechas } from "../../../../utilities/gestion_fechas/FiltrosFechas";
import moment from 'moment';
import { ESTADISTICAS_COLUMNAS_TABLAS } from "../../../../containers/estadisticas/tablas-reportes/ColumnasTablas";
import { CargandoInformacion } from "../../../globales/estadisticas/CargandoInformacion";
import { DescargarReporte } from "../../Reportes/DescargarReporte";
import { useFechaPorDefecto } from "../../hooks/Fechas";
import { SelectorRol } from "../../../globales/estadisticas/SelectorRol";
import { Calendario } from "../../../globales/Calendario";
import { DetalleProfesoresAPI } from "../../../../api/estadisticas/DetalleProfesoresAPI";
import { normalizeString } from "../../../../utilities/StringUtilities";
import PropTypes  from "prop-types";
import { CancelRequestController } from "../../../../utilities/cancel-request-controller";

/**
 * Este componente tiene la función de cargar todas las estadísticas de los ingresos y lecturas de los profesores con base a un rango de fechas.Por otro lado, también se encarga de transformar los datos estadísticos a formato excel para que puedan ser descargados por el usuario.
 */
const IngresosProfesoresComponent = (props) => {
  const { traducciones } = props;
  const { miga_de_pan, ingresos_individuales_profesores, botones } = traducciones;
  const { tabla, descripcion,  resultados, buscador, resumen } = ingresos_individuales_profesores;

  const history = useHistory();
  const state = useTrackedState();
  const queryParams = useQueryParams();
  const fechaPorDefecto = useFechaPorDefecto();
  const dispatch = useDispatch();
  const [filtros, setFiltros] = useState({
    fechas: {
      inicio: fechaPorDefecto.fechaInicio,
      fin: fechaPorDefecto.fechaFin
    }
  })

  const [rangoFechas, setRangoFechas] = useState({
    inicio: FiltroFechas.formatoUsuario(state?.idioma, fechaPorDefecto?.fechaInicio),
    fin: FiltroFechas.formatoUsuario(state?.idioma, fechaPorDefecto?.fechaFin),
  })

  const [estadisticas, setEstadisticas] = useState({
    ingresos: [],
    ingresosFiltrados: []
  });

  const [cargando, setCargando] = useState({
    estadisticas: false
  })



  const actualizarFiltros = (fechas) => {
    dispatch({
      type: "SECCION_ESTADISTICAS_FILTROS",
      property: "fechas",
      value: {inicio:fechas[0], fin:fechas[1]}
    })
    setFiltros({
      ...filtros,
      fechas: {
        inicio: fechas[0],
        fin: fechas[1]
      }
    })
  }


  const filtrarPorInput = ({ value }) => {
    if (value && value.trim().length > 0) {
      const coincidencias = estadisticas?.ingresos.filter(ingreso => normalizeString(ingreso?.nombreCompleto)?.includes(normalizeString(value)));
      setEstadisticas({
        ...estadisticas,
        ingresosFiltrados: coincidencias
      })
    } else {
      setEstadisticas({
        ...estadisticas,
        ingresosFiltrados: estadisticas?.ingresos
      })
    }

  }

  /**
   * transforma la información suministrada por las APIs a una tabla que se puede descargar como excel.
   * @returns tabla para reporte
   */
  const generarInformacionTabla = () => {
    const columnas = ESTADISTICAS_COLUMNAS_TABLAS.ingresosIndividualesProfesores.map(col => {
      const traduccion = traducciones?.ingresos_individuales_profesores?.tabla[`${col?.traduccion}`]
      return { nombreColumna: traduccion || col.textoPorDefecto }
    })

    const filas = [];
    estadisticas?.ingresos.forEach(ingreso => {
      let fila = [];
      ESTADISTICAS_COLUMNAS_TABLAS.ingresosIndividualesProfesores.forEach(col => {
        let valor = ingreso[`${col?.propiedad}`];
        if (Array.isArray(ingreso[`${col?.propiedad}`])) {
          valor = ingreso[`${col?.propiedad}`].join(',')
        }
        fila.push({ valor: valor })
      })
      filas.push(fila);
    })

    const tabla = {
      columnas: columnas,
      filas: filas
    }
    return tabla;
  }


  useEffect(() => {
    setRangoFechas({
      inicio: FiltroFechas.formatoUsuario(state?.idioma, filtros?.fechas?.inicio),
      fin: FiltroFechas.formatoUsuario(state?.idioma, filtros?.fechas?.fin),
    })
  }, [filtros, state?.idioma])



  useEffect(() => {
    const abortController = new CancelRequestController();
    setCargando({
      ...cargando,
      estadisticas: true
    })
    const actualizarEstadisticas = async () => {
      const rangoFechas = {
        inicio: filtros?.fechas.inicio || FiltroFechas.formatoAPI(state?.idioma, moment()),
        fin: filtros?.fechas.fin || FiltroFechas.formatoAPI(state?.idioma, moment())
      };

        await DetalleProfesoresAPI
          .obtenerTodos( {fechaInicio:rangoFechas?.inicio, fechaFin:rangoFechas?.fin, abortSignal: abortController.signal} )
          .then(resultado => {
            setEstadisticas({
              ingresos: resultado,
              ingresosFiltrados: resultado,
            })
            setCargando({
              ...cargando,
              estadisticas: false
            })
          })
          .catch(error => console.log(error))
    
    }
    if (filtros?.fechas?.inicio && filtros?.fechas?.fin ) {
      actualizarEstadisticas();
    }
    return ()=>{
      abortController.abort();
      setCargando({
        ...cargando,
        estadisticas: true
      })
    }
  }, [JSON.stringify(filtros)])


  return (
    <>
      <MigasDePan>
        <Miga
          texto={miga_de_pan?.estadisticas || 'Estadisticas'}
          alSeleccionar={() => {
            history.push('/estadisticas')
          }} />
        <Miga
          texto={miga_de_pan?.ingresos_individuales || 'Ingresos individuales'}
          esRutaActual={true}
        />
      </MigasDePan>

      <div className="contenido">
        <h1 className="titulos-principales">{`${ingresos_individuales_profesores?.seccion?.profesor?.titulo || 'Ingresos individuales de profesores'}`}</h1>
        <p className="informacion-principal">{descripcion}</p>
        <div className="mt-4 md:w-4/12 xl:w-3/12">
        <Calendario
               fechaMaxima={moment().format('YYYY-MM-DD')}
               fechaMinima={state?.datosInstitucion?.fechaInicioSuscripcion || ''}
               modoRango={true}
               fechaPorDefecto={ [
                state?.estadisticas?.filtros?.fechas?.inicio || queryParams.get('fechaInicio') || fechaPorDefecto?.inicio, 
                state?.estadisticas?.filtros?.fechas?.fin || queryParams.get('fechaFin') || fechaPorDefecto.fin
              ]}
               zIndex={9999}
               modoMultiple={false}
               placeholder={''}
               alCambiar={(fechas)=>actualizarFiltros(fechas)}
        />
        </div>
        <hr class="my-8"/>
        <SelectorRol
          alSeleccionarRol={(rol) => {
            if (rol === 'estudiante') {
              history.push({
                pathname: '/estadisticas/ingresos-individuales/estudiantes',
                search: `?fechaInicio=${filtros?.fechas?.inicio}&fechaFin=${filtros?.fechas?.fin}`
              })
            }
          }
          }
          rolPorDefecto={'profesor'}
          textos={{
            estudiante:ingresos_individuales_profesores?.selector_rol?.estudiante || 'Ingresos individuales de estudiantes',
            profesor:ingresos_individuales_profesores?.selector_rol?.profesor || 'Ingresos individuales de profesores'
          }}
        />
        <hr class="my-8"/>

        {Boolean(cargando?.estadisticas) === true ?
          <CargandoInformacion />

          : <>
            <div className="mb-8">
              <div tabIndex={0} className="focusable-red text-center lg:text-left  mt-5 sm:mt-0 ">
                <p className='q5-32 red-inv-var2--color '>
                  <span className='icon-star-full text-30 mr-3'></span>
                  {estadisticas?.ingresos?.length}  {estadisticas?.ingresos?.length !== 1 ? resumen.plural : resumen.singular}
                </p>
                <p className="r5-14-negro4A">{resumen.descripcion}</p>
              </div>
            </div>

            <TituloSeccion
              titulo={ingresos_individuales_profesores?.seccion?.profesor?.detalle_de || 'Detalle de profesores'}
              fecha={`${rangoFechas.inicio || 'N/A'} - ${rangoFechas.fin || 'N/A'}`}
              input={{
                placeHolder: buscador?.placeholder || 'Encuentra un profesor',
                textoBorrarFiltro: 'Borrar'
              }}
              alEscribir={(value) => {
                filtrarPorInput(value)
              }}
              elementosPersonalizados={
                <div className="my-2 w-full flex  justify-center sm:justify-end">
                  <DescargarReporte
                    nombreArchivo={`${ingresos_individuales_profesores?.seccion?.profesor?.titulo || 'Ingresos individuales (profesores)'} (${rangoFechas?.inicio} - ${rangoFechas?.fin}) `}
                    tablaInformacion={generarInformacionTabla()}
                  />
                </div>
              }
            />

            <div className="background-var3--bg  mt-5 xl:p-5 rounded-lg">
              <TablaIngresos
                filtros={filtros}
                datos={estadisticas?.ingresosFiltrados}
                textosTabla={{ tabla: tabla, boton: botones.ver_detalle, resultados: resultados }}
              />
            </div>

          </>
        }
      </div>
    </>
  )
}
export default IngresosProfesoresComponent;

IngresosProfesoresComponent.propTypes = {
  /**
   * Objeto con los textos que se deben renderizar en la sección
   */
  traducciones: PropTypes.object.isRequired,
}